// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7af4a80","239":"be0d2136","453":"abd36b29","667":"00ac4414"}[chunkId] + ".chunk.js";
};